
import React from 'react';
import { useLanguage } from '@/context/LanguageContext';

export const TourDetailError: React.FC = () => {
  const { language } = useLanguage();
  
  return (
    <div className="museum-container py-16 text-center">
      <h1 className="section-title mb-6">
        {language === 'en' ? 'Tour not found' : 'הסיור לא נמצא'}
      </h1>
      <p className="mb-6">
        {language === 'en' 
          ? 'The tour you are looking for does not exist or has been removed.' 
          : 'הסיור שאתה מחפש אינו קיים או הוסר.'}
      </p>
    </div>
  );
};
